import {
  useDepartmentOptionsGet,
  useProLaborLevelDesignations,
} from '@sbv-clients/data-access-api';

import {
  BaseFieldProps,
  createOptionsFieldBuilder,
} from '../hoc/fields-builder';

const dataFetcher = useDepartmentOptionsGet;
type ExtraParameters = Parameters<typeof dataFetcher>[0];
type Props = BaseFieldProps & ExtraParameters;

const hookParamsGetter = (props: Props): ExtraParameters => ({
  facilityId: props.facilityId,
  filteredByOpeningTemplates: props.filteredByOpeningTemplates,
});

export const {
  DepartmentSelectField,
  DepartmentFormSelectField,
  DepartmentDataGridSelectField,
  DepartmentIdToLabelRenderer,
} = createOptionsFieldBuilder({
  prefix: 'Department',
  useOptionsHook: dataFetcher,
  extractHookParams: hookParamsGetter,
  useLabelHook: () =>
    useProLaborLevelDesignations()?.DepartmentLaborLevel ?? '',
});
